import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function FrameInspectIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M2 17a1 1 0 0 1 1 1 3 3 0 0 0 3 3 1 1 0 1 1 0 2 5 5 0 0 1-5-5 1 1 0 0 1 1-1M13 6a7 7 0 0 1 5.605 11.191l3.102 3.102.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-3.102-3.102A7 7 0 1 1 13 6m0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10M6 1a1 1 0 0 1 0 2 3 3 0 0 0-3 3 1 1 0 0 1-2 0 5 5 0 0 1 5-5M18 1a5 5 0 0 1 5 5 1 1 0 1 1-2 0 3 3 0 0 0-3-3 1 1 0 1 1 0-2" />
    </Icon>
  );
}

FrameInspectIcon.displayName = 'FrameInspectIcon';
